const areas = [
  "Pleasant Hill", "Walnut Creek", "Lafayette", "Concord",
  "Martinez", "Orinda", "Moraga", "Danville",
  "San Ramon", "Alamo", "Clayton", "Pittsburg",
];

export default function ServiceAreas() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 text-xs font-bold tracking-[0.2em] uppercase">Service Areas</span>
          <h2
            className="text-4xl md:text-5xl font-black text-gray-950 mt-3 mb-4 leading-tight tracking-tight"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Serving the East Bay
          </h2>
          <p className="text-gray-500 text-base max-w-md mx-auto leading-relaxed">
            Solar, battery storage, EV charging, and electrical services across Contra Costa County and the greater East Bay.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 items-stretch">

          {/* Map */}
          <div className="w-full lg:w-[58%] rounded-2xl overflow-hidden border border-gray-200" style={{ minHeight: "440px" }}>
            <iframe
              title="Wired Into The Future Service Area — East Bay, CA"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50470.12345678!2d-122.0597!3d37.9485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808566b5e5e5e5e5%3A0x0!2sPleasant%20Hill%2C%20CA!5e0!3m2!1sen!2sus!4v1680000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "440px", display: "block" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Right panel */}
          <div className="w-full lg:flex-1 flex flex-col justify-between gap-8">
            <div>
              <h3
                className="text-xl font-black text-gray-900 mb-2"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                Communities We Serve
              </h3>
              <p className="text-gray-500 text-sm mb-6 leading-relaxed">
                Our licensed team covers most of Contra Costa County. Don&apos;t see your city? Call us — we likely serve your area.
              </p>

              <div className="flex flex-wrap gap-2">
                {areas.map((area) => (
                  <span
                    key={area}
                    className="bg-white hover:bg-amber-50 hover:text-amber-700 border border-gray-200 hover:border-amber-300 text-gray-700 text-sm font-medium px-3.5 py-1.5 rounded-full transition-all cursor-default"
                  >
                    {area}
                  </span>
                ))}
              </div>
            </div>

            {/* CTA card */}
            <div className="bg-stone-950 rounded-2xl p-7">
              <div className="flex items-start gap-3 mb-5">
                <div className="w-9 h-9 flex items-center justify-center bg-amber-500/20 rounded-lg flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-line text-amber-400"></i>
                </div>
                <div>
                  <div className="text-white font-bold text-sm mb-1">Not sure if we cover your area?</div>
                  <div className="text-white/50 text-sm leading-relaxed">
                    Call us at{" "}
                    <a href="tel:9258723408" className="text-amber-400 font-semibold hover:text-amber-300 transition-colors">
                      (925) 872-3408
                    </a>{" "}
                    — we cover most of the East Bay.
                  </div>
                </div>
              </div>
              <button
                onClick={() => scrollTo("#contact")}
                className="w-full bg-amber-500 hover:bg-amber-400 text-white font-bold py-3 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                Request a Free Estimate
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
